import React from "react";
import { pathimagenes } from "../../Helpers/Accesos";
import { IconosAside } from "./IconosAside";
import { useHistory } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import request from "../../Helpers/API";
import Swal from "sweetalert2";

export const AsideScreen = () => {
  const { modulos, roles } = useSelector((state) => state.sesion);

  const collapsed = useSelector((state) => state.globalState.HDMenuCollapsed); // estado global
  // Drawer del menu en pantallas chicas; en escritorio la clase no tiene efecto.
  const drawerAbierto = useSelector((state) => state.globalState.HDMenuDrawerAbierto);
  const dispatch = useDispatch();
  const history = useHistory();

  const rolesObligatoriosClientes = ["CRCE"];

  const cerrarDrawer = () => dispatch({ type: "MENU_DRAWER_CLOSE" });

  const onClick = (path) => {
    cerrarDrawer();
    if (roles.some(rol => rolesObligatoriosClientes.includes(rol.idrol))) {
      request
        .get(`ClientesNoRegistrados/Listado?sucursales=${0}&ADR=${"1,2"}`)
        .then((result) => {
          if (result.length > 0) {
            history.push("/Credito/ClientesnoRegistrados");
          }
          else {
            history.push(path);
          }
        })
        .catch((error) => {
          Swal.fire("Bucar", JSON.stringify(error), "error");
        });

    } else {
      history.push(path);
    }
  };

  const toggleCollapse = () => {
    if (collapsed) {
      dispatch({ type: "MENU_EXPANDED" });
    } else {
      dispatch({ type: "MENU_COLLAPSED" });
    }
  };

  const uniqueModulos = new Set(modulos.map((modulo) => modulo.idmodulo));

  return (
    <>
      {drawerAbierto && <div className="hd-aside-backdrop" onClick={cerrarDrawer} />}
      <div id="hd-aside-screen" className={drawerAbierto ? "is-open" : ""}>
      <div className={`${collapsed ? "hd-collapsed-menu" : "hd-aside-menu"} scroll-4`}>

        <div className={`${collapsed ? "hd-aside-menu-collapsed-btn-contianer-collapsed" : "hd-aside-menu-collapsed-btn-contianer-aside"}`}>
          <button
            className="hd-aside-toggle-btn"
            onClick={toggleCollapse}
            aria-label={collapsed ? "Expandir menú" : "Colapsar menú"}
          >
            {collapsed ? "▶" : "◀"}
          </button>
        </div>

        <div className="hd-aside-imagen-empresa">

          {!collapsed && (
            <img
              src={`${pathimagenes}/logo-2.png`}
              onClick={() => history.push(`/Home/Dashboard`)}
              alt="Logo"
            />
          )}
        </div>

        {modulos?.length > 0 &&
          Array.from(uniqueModulos).map((idmodulo) => {
            const modulo = modulos.find((m) => m.idmodulo === idmodulo);
            return (
              <div
                key={modulo.idmodulo}
                className="hd-aside-menu-item"
                onClick={() => onClick(modulo.ruta)}
              >
                <div className="icon-wrapper">
                  <IconosAside icono={modulo.icono} />
                  {collapsed && <span className="tooltip">{modulo.descripcion}</span>}
                </div>
                {!collapsed && <span>{modulo.descripcion}</span>}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};